export const LivePersonConfig = {
   livePersonPath :"{0}/iframe-le-tag/iframe-cs.html?lpsite={1}&amp;lpsection={2}&amp;buttons={3}",
   livePersonDomain: "https://publisher.liveperson.net",
   livePersonSiteID: "60270350", 
}